import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asuvi-section-header',
  templateUrl: './asuvi-section-header.component.html',
  styleUrls: ['./asuvi-section-header.component.scss']
})
export class AsuviSectionHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
